module.exports = __webpack_public_path__ + "static/img/lenovoYOGATab3Plus.9bd46c07.png";